import React, { useState, useEffect } from 'react'
import AuthLayout from '../../../../layout/AuthLayout'
import { useDispatch } from 'react-redux'
import { updateRoute } from '../../../../store/dataRoute'
import { Box, Flex, Text, Group, Modal } from '@mantine/core'
import { getListUserMemberships } from '../../../../services/users'
import LoadingData from '../../../../component/ui/LoadingData'
import NoData from '../../../../component/ui/NoData'
import TableMembershipList from '../../../../component/pages/Users/Membership/TableMembershipList'
import classes from '../../../../assets/module-css/AdminLayout.module.css'
import FormAdjustMembership from '../../../../component/pages/Users/Membership/FormAdjustMembership'

const labelTable = [
  {
    label: 'ID',
    width: 30
  },
  {
    label: 'Role',
    width: 200
  },
  {
    label: 'Limitation by URL',
    width: 'auto'
  },
  {
    label: 'Limitation to My Products',
    width: 'auto'
  },
  {
    label: 'Action',
    width: 50
  },
]

const LimitationList = () => {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(true)
  const [membershipUserList, setMembershipUserList] = useState([])
  const [totalUser, setTotalUser] = useState(0)
  const [openModalForm, setOpenModalForm] = useState(false)
  const [detailData, setDetailData] = useState(null)

  const mappingRoute = [
    {
      label: '/',
      route: null
    },
    {
      label: 'users',
      route: null
    },
    {
      label: 'limitations',
      route: null
    },
  ]

  const handleGetListUserMemberships = async () => {
    setLoading(true)
    const params = {
      '[fields][membership]': 'id,name,limit',
    }
    try {
      const response = await getListUserMemberships(params)
      if (response.data.success) {
        const { data } = response.data

        const filterMembership = data.filter((item) =>
          item.attributes.id === 2 ||
          item.attributes.id === 3 ||
          item.attributes.id === 4 ||
          item.attributes.id === 5 ||
          item.attributes.id === 19 ||
          item.attributes.id === 21
        )

        const remapData = filterMembership.map((val) => {
          return {
            ...val.attributes,
          }
        })

        const countData = filterMembership.length || 0

        setMembershipUserList(remapData)
        setTotalUser(countData)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }

  }

  useEffect(() => {
    dispatch(updateRoute({ 'data': mappingRoute }))
    // eslint-disable-next-line
  }, [dispatch])

  useEffect(() => {
    handleGetListUserMemberships()
    // eslint-disable-next-line
  }, [])

  const actions = {
    edit: (val) => {
      setDetailData(val)
      setOpenModalForm(true)
    },
  }

  const handleAction = (val, type) => {
    return actions[type](val)
  }

  const onCloseModalForm = () => {
    setOpenModalForm(false)
    setDetailData(null)
  }

  return (
    <AuthLayout>
      <Box my={20}>
        <Box>
          <Flex justify='space-between' align="end" mb={30}>
            <Text className={classes.titleLayout}>Membership Limitations</Text>
          </Flex>
          <Group my={10} gap='xs'>
            <Text fz={12}>Total Data Found: </Text>
            <Text fz={12} fw='bold'>{loading ? 0 : totalUser} Data </Text>
          </Group>

          <Box my={30}>
            {loading ? <LoadingData /> : membershipUserList.length > 0 ? <TableMembershipList label={labelTable} data={membershipUserList} actionMethod={handleAction} /> : <NoData />}
          </Box>
        </Box>
      </Box>
      <Modal opened={openModalForm} onClose={onCloseModalForm} centered closeOnClickOutside={false} size='md' title={<Text fw='Bold'>Update Membership Limitation</Text>} withCloseButton={false}>
        <FormAdjustMembership dataMembership={detailData} onCloseForm={onCloseModalForm} reloadList={handleGetListUserMemberships} />
      </Modal>
    </AuthLayout>
  )
}

export default LimitationList